// extracted by mini-css-extract-plugin
export default {"Auth__option":"SignupBox_Auth__option__SFva1"};